module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Patricia Davids\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("USA Today best-selling author Patricia Davids was born in Kansas. After forty years as an NICU nurse, Pat switched careers to become an inspirational writer. She now enjoys laid back life on a Kansas farm, spending time with her family and playing with her dog Sugar, who thinks fetch should be a twenty-four hour a day game. When not throwing a ball, Pat is happily dreaming up new stories where love and faith conquer all. Contact her at pat@patriciadavids.com."), _c('Br', [_c('Br', [_vm._v(" ")])], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/7MoiKU/tc-custom/9781459282490.jpg?1724929464272",
      "alt": "This image is the cover for the book Christmas Quilt, Brides of Amish Country"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Christmas Quilt, Brides of Amish Country\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_c('i', [_vm._v("USA Today")]), _vm._v("–Bestselling Author: It’s Christmastime in Amish country, and hope is the greatest gift of all . . . ")]), _c('br'), _c('br'), _vm._v("Years ago, Rebecca Beachy kept her reasons for rejecting Gideon Troyer’s marriage proposal a secret. Then Gideon left their Amish community. Now, Rebecca crafts quilts to raise money to cure her blindness. She’s also busy guarding her heart against love. . . . until Gideon returns, at risk of being shunned, to make the winning bid on one of her exquisite quilts. Will the quilt—a patchwork promise of rediscovered love—bring Gideon and Rebecca back together again?"), _c('br'), _c('br'), _c('b', [_vm._v("Praise for Patricia Davids’ novels")]), _c('br'), _c('br'), _vm._v("“Uplifting . . . will have fans of Amish romance eager to read more from Davids.” —"), _c('i', [_vm._v("Publishers Weekly")]), _c('br'), _c('br'), _vm._v("“Patricia writes with heart, integrity and hope. Her stories both entertain and edify—the perfect combination.” —Kim Vogel Sawyer, bestselling author of "), _c('i', [_vm._v("The Tapestry of Grace")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0